document.addEventListener('DOMContentLoaded', function() {
    // Function to check if element is in viewport
    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    
    // Function to animate counting
    function animateCount(element, target, duration) {
      let start = 0;
      const increment = Math.ceil(target / (duration / 16)); // Approximate frames in duration
      
      function updateCount() {
        start += increment;
        if (start >= target) {
          element.textContent = target.toLocaleString();
          return;
        }
        element.textContent = start.toLocaleString();
        requestAnimationFrame(updateCount);
      }
      
      updateCount();
    }
    
    // Get all stat counter elements
    const statElements = document.querySelectorAll('.tpt-statistics-1_counter');
    
    // Function to check and start animations
    function checkAndAnimate() {
      statElements.forEach(function(statElement) {
        if (isInViewport(statElement) && !statElement.classList.contains('animated')) {
          statElement.classList.add('animated');
          
          // Get the target value
          const targetValue = parseInt(statElement.getAttribute('data-target'));
          const duration = parseInt(statElement.getAttribute('data-duration')) || 2000;
          
          // Store original text to restore unit after animation
          const unitElement = statElement.parentNode.querySelector('.tpt-statistics-1_unit');
          const unit = unitElement ? unitElement.textContent : '';
          
          // Start with 0
          statElement.textContent = '0';
          
          // Animate to target over specified duration
          animateCount(statElement, targetValue, duration);
          
          // If there's a unit, we don't need to add it back since it's in a separate element
          // The unit will remain visible throughout the animation
        }
      });
    }
    
    // Function to check if user prefers reduced motion
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    
    // If user prefers reduced motion, show final values immediately
    if (prefersReducedMotion()) {
      statElements.forEach(function(statElement) {
        const targetValue = parseInt(statElement.getAttribute('data-target'));
        statElement.textContent = targetValue.toLocaleString();
        statElement.classList.add('animated');
      });
    } else {
      // Check on scroll
      window.addEventListener('scroll', checkAndAnimate);
      
      // Check on initial load
      checkAndAnimate();
    }
    
    // Handle page visibility change to restart animations if needed
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden && !prefersReducedMotion()) {
        // Page became visible again, check for any unanimated counters
        const unanimatedCounters = document.querySelectorAll('.tpt-statistics-1_counter:not(.animated)');
        if (unanimatedCounters.length > 0) {
          checkAndAnimate();
        }
      }
    });
    
    // Utility function to reset all counters (useful for dynamic content)
    window.resetStatisticsCounters = function() {
      if (prefersReducedMotion()) {
        return; // Don't reset if user prefers reduced motion
      }
      
      const counters = document.querySelectorAll('.tpt-statistics-1_counter');
      counters.forEach(counter => {
        counter.classList.remove('animated');
        counter.textContent = '0';
      });
      checkAndAnimate();
    };
  });